import { render, staticRenderFns } from "./_editorMl.vue?vue&type=template&id=dd8bc466"
import script from "./_editorMl.vue?vue&type=script&lang=js"
export * from "./_editorMl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports